
import createIconComponent from '../utils/createIconComponent';
import { SVG_MORE_MENU_VERTICAL_OUTLINED } from '../../../dist';
import React from 'react';
const MoreMenuVerticalOutlinedIcon = createIconComponent({ content: SVG_MORE_MENU_VERTICAL_OUTLINED, height: 24, width: 24 });
MoreMenuVerticalOutlinedIcon.displayName = 'MoreMenuVerticalOutlinedIcon';
export default MoreMenuVerticalOutlinedIcon;
